import { RouteConfig } from "vue-router";

const AuthLayout = () => import("@/modules/auth/layouts/AuthLayout.vue");
const AuthLogin = () => import("@/modules/auth/pages/AuthLogin.vue");
const AuthChangePassword = () => import("@/modules/auth/pages/AuthChangePassword.vue");
const AuthInsufficientAccess = () => import("@/modules/auth/pages/AuthInsufficientAccess.vue");

export const routes: RouteConfig[] = [
  {
    path: "/auth",
    component: AuthLayout,
    children: [
      {
        path: "login",
        name: "AuthLogin",
        component: AuthLogin,
      },
      {
        path: "change-password",
        name: "AuthChangePassword",
        component: AuthChangePassword,
      },
      {
        path: "insufficient-access",
        name: "AuthInsufficientAccess",
        meta: {
          requiresAuth: true,
        },
        component: AuthInsufficientAccess,
      },
    ],
  },
];
